import { Button } from '@dynamika-shared/ui/Button/Button';
import { VisitConfigQuestionnaires } from '@dynamika-shared/types/visits';
import { getValueWithTooltip } from '@dynamika-shared/ui/Table/getValueWithTooltip';
import { FormsControlSchemaType } from 'src/pages/ClinicalTrial/uiControlSchemaByStatus/ControlTypes';
import { TableRecord } from '@dynamika-shared/ui/TableNew/TableNew';

type AssignFormClickHandler = (
  visit: VisitConfigQuestionnaires,
  templateType: 'form'
) => void;

const MAX_LENGTH_NAME = 30;
export const transformVisits = (
  visits: VisitConfigQuestionnaires[],
  uiControlSchema: FormsControlSchemaType,
  assignFormAction: AssignFormClickHandler,
  isPM: boolean = false
) => {
  return visits.map(visit => {
    return {
      ...visit,
      disabled: !visit.questionnaires.length,
      name: getValueWithTooltip('name', MAX_LENGTH_NAME)(visit),
      action: (
        <div className='flex justify-end gap-1'>
          {!uiControlSchema.assignForm.hidden && !isPM && (
            <Button
              iconType='plus'
              iconClassName={'w-2 h-2'}
              type='text'
              className='without-bg'
              onClick={e => {
                e.stopPropagation();
                assignFormAction(visit, 'form');
              }}
              data-testid={`assignForm-${visit.id}`}
            >
              Assign Form
            </Button>
          )}
        </div>
      ),
    };
  }) as unknown as (TableRecord &
    VisitConfigQuestionnaires & { disabled?: boolean })[];
};
